import { Box, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import Text from "./text/Text";
import {
  applyCode,
  codeApplied,
  optional,
  promoHeading,
  promoLabel,
  promoPlaceholder,
  promoSubtitle,
  remove,
} from "./messages";
import CloseIcon from "@mui/icons-material/Close";
import { checkCircle, promoCodeIcon } from "./images";
import { Input } from "./input/Input";
import Button from "./button/Button";
import { callAPIInterface } from "./constants";
import { CustomLink } from "./link/Link";
import CommonDrawer from "./drawer/CommonDrawer";
import { store } from "../redux/store";
import { showToast } from "../redux/actions";

const ApplyPromoCode = ({ formik, isFromBrowser }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [isCodeApplied, setIsCodeApplied] = useState(false);

  const { values, setFieldValue } = formik;

  const handleCloseDrawer = () => {
    setPromoCode("");
    setIsDrawerOpen(false);
  };

  const handleApplyClick = () => {
    if (isCodeApplied) {
      setPromoCode("");
      setFieldValue("referralCode", "");
      setIsCodeApplied(false);
    } else {
      if (values?.country) {
        setIsDrawerOpen(true);
      }
    }
  };

  const validatePromoCode = async (promoCode) => {
    const data = {
      country: values?.country,
      referral_code: promoCode,
    };
    try {
      await callAPIInterface("POST", "/referral/validate", data);
      setFieldValue("referralCode", promoCode);
      setErrorMsg("");
      setIsCodeApplied(true);
      setIsDrawerOpen(false);
    } catch (error) {
      const promoApiData = {
        name: promoCode,
        account_type: "Wallet",
        avail_on: "SIGNUP",
        country_code: values?.country,
      };
      const res = await callAPIInterface(
        "POST",
        "/promo-code/validate",
        promoApiData
      );
      if (res?.is_valid) {
        setFieldValue("promoCode", promoCode);
        setErrorMsg("");
        setIsCodeApplied(true);
        setIsDrawerOpen(false);
      } else {
        store.dispatch(
          showToast({
            isToastOpen: true,
            toastMessage: res.message,
            toastVariant: "error",
          })
        );
        setErrorMsg(res?.message);
      }
    }
  };

  useEffect(() => {
    const referralCode = localStorage.getItem("referralCode");
    if (referralCode) {
      setPromoCode(referralCode);
      setFieldValue("referralCode", referralCode);
      setIsCodeApplied(true);
    }
  }, []);

  const renderLayout = () => {
    return (
      <Box padding={"16px"}>
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <CloseIcon
            sx={{
              color: "#848B9E",
              height: "24px",
              width: "24px",
              cursor: "pointer",
            }}
            onClick={handleCloseDrawer}
          />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          mb="24px"
          alignItems="center"
          rowGap={1}
          textAlign="center"
        >
          <img src={promoCodeIcon} height="54px" width="54px" />
          <Text className="default-text" size={20} font="bold">
            {promoHeading}
          </Text>
          <Text className="default-text" size={16} font="regular">
            {promoSubtitle}
          </Text>
        </Box>
        <Input
          fullWidth
          showLabel
          error={errorMsg}
          label={promoLabel}
          placeholder={promoPlaceholder}
          name="promocode"
          value={promoCode}
          type="text"
          onChange={(e) => {
            setPromoCode(e.target.value);
          }}
          inputProps={{
            maxLength: 40,
          }}
        />
        <Button
          sx={{ mt: "24px" }}
          fullWidth
          variant="contained"
          label={applyCode}
          onClick={() => {
            validatePromoCode(promoCode);
          }}
          disabled={!promoCode}
          {...(!isFromBrowser && { textClass: "font-14" })}
        />
      </Box>
    );
  };

  const applyLinkText = isCodeApplied ? (
    remove.toUpperCase()
  ) : (
    <>
      {applyCode.toUpperCase()}
      <span style={{ color: "#848B9E" }}>
        {" (" + optional.toUpperCase() + ")"}
      </span>
    </>
  );

  return (
    <>
      <Box
        className="mt-16 apply-promo-code"
        display="flex"
        alignItems="flex-start"
        gap={1}
      >
        <img
          src={isCodeApplied ? checkCircle : promoCodeIcon}
          height="20px"
          width="20px"
        />

        <Box display="flex" flexDirection="column" gap={0.5}>
          <Text className="default-text" size={14} font="semibold">
            {isCodeApplied
              ? codeApplied(values?.referralCode || values?.promoCode)
              : promoHeading}
          </Text>
          <CustomLink
            color={
              isCodeApplied ? "error" : values?.country ? "primary" : "#848B9E"
            }
            style={{
              fontSize: "12px",
              fontWeight: "600",
            }}
            onClick={handleApplyClick}
          >
            {applyLinkText}
          </CustomLink>
        </Box>
      </Box>
      {isFromBrowser ? (
        <Dialog open={isDrawerOpen} onClose={handleCloseDrawer}>
          {renderLayout()}
        </Dialog>
      ) : (
        <CommonDrawer
          anchor="bottom"
          open={isDrawerOpen}
          onClose={handleCloseDrawer}
        >
          {renderLayout()}
        </CommonDrawer>
      )}
    </>
  );
};

export default ApplyPromoCode;
